import '../../util/i18n.js'
import '../../global.css'
import React from 'react'
import * as classes from './layout.module.css'
import Navigator from '../navigators/navigator'
import NavFooter from '../footers/nav-footer'
import AppContextProvider from '../../store/app-context'

const Layout: React.FC<{children: React.ReactNode}> = ({children}) => {
  try {
    return (
      <AppContextProvider>
        <div className={classes.container}>
          <Navigator />
          {children}
          <NavFooter />
        </div>
      </AppContextProvider>
    )
  } catch (e) {return null}
}

export default Layout;